import { render, staticRenderFns } from "./HistoryCard.vue?vue&type=template&id=0942edf5&scoped=true&"
import script from "./HistoryCard.vue?vue&type=script&lang=js&"
export * from "./HistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./HistoryCard.vue?vue&type=style&index=0&id=0942edf5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0942edf5",
  null
  
)

export default component.exports